import Vue from 'vue'
import grid from './grid/index.vue'
import edit from './edit/index.vue'
import select from './select.vue'

Vue.component('app-tabelapreco-grid', grid)
Vue.component('app-tabelapreco-edit', edit)
Vue.component('app-tabelapreco-select', select)
